/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true  */
/*global console: true  */

expocadfx.Exhibitor = function( cnt, xml, decrypt, jsonObject) {
	'use strict';
    var i = 0;
    var arrCat;
    var len = 0;
    var exh = {
        id: cnt,        /* Needed for slick grid sort and filter */
        status: "0",
        name : "",
        exhId : "",
        boothNumber : "",
        boothIndex : "",
		favorite: false,
		local: true,
        address1 : "",
        address2 : "",
        city : "",
        state : "",
        zip : "",
        country : "",
        contact : "",
        phone : "",
        fax : "",
        email : "",
        website : "",
        profile : "",
        category : "",
        url : "",
        directoryUrl : "",
        companyLogo : null
    };
    
    if( xml !== null) {
        exh.name = xml.getAttribute("n");
        exh.exhId = xml.getAttribute("cID");
        exh.boothNumber = xml.getAttribute("bID");
        exh.boothIndex = xml.getAttribute("bIX");
        exh. address1 = xml.getAttribute("a1");
        exh.address2 = xml.getAttribute("a2");
        exh.city = xml.getAttribute("c");
        exh.state = xml.getAttribute("s");
        exh.zip = xml.getAttribute("z");
        exh.country = xml.getAttribute("cr");
        exh.contact = xml.getAttribute("ct");
        exh.phone = xml.getAttribute("p");
        exh.fax = xml.getAttribute("f");
        exh.email = xml.getAttribute("e");
        exh.website = xml.getAttribute("w");
        exh.profile = xml.getAttribute("pf");
        exh.category = xml.getAttribute("cg");
        exh. url = xml.getAttribute("url");
    
        if( typeof(decrypt) === "function") {
            //  url is not encrypted, exhId is not decrypted ( PROBLEM IN SALES !!)
            exh.name = decrypt( exh.name);
            exh.address1 = decrypt( exh.address1);
            exh.address2 = decrypt( exh.address2);
            exh.city = decrypt( exh.city);
            exh.state = decrypt( exh.state);
            exh.zip = decrypt( exh.zip);
            exh.country = decrypt( exh.country);
            exh.contact = decrypt( exh.contact);
            exh.phone = decrypt( exh.phone);
            exh.fax = decrypt( exh.fax);
            exh.email = decrypt( exh.email);
            exh.website = decrypt( exh.website);
            exh.profile = decrypt( exh.profile);

            arrCat = exh.category.split( "x%x");		// separator used by EXPOCAD
            len = arrCat.length;
            for( i = 0; i < len; i++)  {
                arrCat[i] = decrypt( arrCat[i]);
            }
            exh.category = arrCat.join( "x%x");
        }

        try {
            exh.name = exh.name.trim();
        }
        catch( ex) {
            console.log( "Browser does not support trim function");
        }
    }
    if  (jsonObject != null || jsonObject != undefined) {

        if (jsonObject.displayName != ""){
            exh.name = jsonObject.displayName;
        }
        else{
            exh.name = "Available Booth";
        }
        
        exh.exhId = jsonObject.customerId;
        if ( exh.exhId === null){
            exh.exhId = "";
        }
        
        exh.boothNumber = jsonObject.boothNumber;
        exh.boothIndex = jsonObject.boothIndex;
        exh.address1 = jsonObject.address1;
        exh.address2 = jsonObject.address2;
        exh.city = jsonObject.city;
        exh.state = jsonObject.state;
        exh.zip = jsonObject.postalCode;
        exh.country = jsonObject.country;
        exh.contact = jsonObject.contact;
        exh.phone = jsonObject.phone;
        exh.fax = jsonObject.fax;
        exh.email = jsonObject.email;
        exh.website = jsonObject.website;
        exh.profile = jsonObject.productDescription;
        exh.category = jsonObject.category;
        exh.url = jsonObject.url; // If populated, clicking on this booth will navigate the user to this URL
        exh.directoryUrl = jsonObject.directoryUrl;
        exh.companyLogo = jsonObject.companyLogo;
    
        if( typeof(decrypt) === "function") {
            //  url is not encrypted, exhId is not decrypted ( PROBLEM IN SALES !!)
            exh.name = decrypt( exh.name);
            exh.displayName = decrypt( exh.displayName);
            exh.address1 = decrypt( exh.address1);
            exh.address2 = decrypt( exh.address2);
            exh.city = decrypt( exh.city);
            exh.state = decrypt( exh.state);
            exh.zip = decrypt( exh.zip);
            exh.country = decrypt( exh.country);
            exh.contact = decrypt( exh.contact);
            exh.phone = decrypt( exh.phone);
            exh.fax = decrypt( exh.fax);
            exh.email = decrypt( exh.email);
            exh.website = decrypt( exh.website);
            exh.profile = decrypt( exh.profile);

            arrCat = exh.category.split( "x%x");		// separator used by EXPOCAD
            len = arrCat.length;
            for( i = 0; i < len; i++)  {
                arrCat[i] = decrypt( arrCat[i]);
            }
            exh.category = arrCat.join( "x%x");
        }

        try {
            exh.name = exh.name.trim();
        }
        catch( ex) {
            console.log( "Browser does not support trim function");
        }
    }
    return exh;
};